export default defineNuxtRouteMiddleware((to, _from) => {
  const user = useStrapiUser<{ enabled: boolean }>()

  if (!user.value && to.fullPath.startsWith('/auth')) {
    return
  }

  if (!user.value) {
    useCookie('redirect', { path: '/' }).value = to.fullPath
    return navigateTo('/auth/login')
  }

  if (user.value && to.fullPath.startsWith('/auth')) {
    return navigateTo('/')
  }

  if (user.value.enabled === false && to.fullPath !== '/verification') {
    return navigateTo('/verification')
  }

  if (user.value.enabled === true && to.fullPath === '/verification') {
    return navigateTo('/')
  }
})
